import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { HeaderComponent } from './Shared/header/header.component';
import { FooterComponent } from './Shared/footer/footer.component';
import { HomeComponent } from './Components/home/home.component';
import { FeaturesComponent } from './Components/features/features.component';
import { ExamplesComponent } from './Components/examples/examples.component';
import { PricingComponent } from './Components/pricing/pricing.component';
import { EnterpriseComponent } from './Components/enterprise/enterprise.component';
import { wordpluginComponent } from './Components/word-plugin/word-plugin.component';
import { TrinkaCloudComponent } from './Components/trinka-cloud/trinka-cloud.component';
import { AboutUsComponent } from './Components/about-us/about-us.component';
import { ContactUsComponent } from './Components/contact-us/contact-us.component';
import { WorkWithUsComponent } from './Components/work-with-us/work-with-us.component';
import { PrivacyPolicyComponent } from './Components/privacy-policy/privacy-policy.component';
import { TermServicesComponent } from './Components/term-services/term-services.component';
import { PageNotFoundComponent } from './Components/page-not-found/page-not-found.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './models/material-components.service';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { MaterialModuleList } from './material-module';
import { NgtUniversalModule } from '@ng-toolkit/universal';
import { AppComponent } from './app.component';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { GcEditorComponent } from './Components/gc-editor/gc-editor.component';
import { BrowserPluginComponent } from './Components/browser-plugin/browser-plugin.component';
import { AutoEditComponent } from './Components/auto-edit/auto-edit.component';
import { CompareComponent } from './Components/compare/compare.component';
import { WhitePaperComponent } from './Components/white-paper/white-paper.component';
import { PublicationChecksComponent } from './Components/publication-checks/publication-checks.component';
import { ChangelogfyModule } from "changelogfy-angular";
import { FAQComponent } from './Components/faq/faq.component';
import { TrinkaVsGrammarlyComponent } from './Components/trinka-vs-grammarly/trinka-vs-grammarly.component';
import { TrinkaVsGingerComponent } from './Components/trinka-vs-ginger/trinka-vs-ginger.component';
import { TrinkaVsLanguagetoolComponent } from './Components/trinka-vs-languagetool/trinka-vs-languagetool.component';
import { TrinkaVsWritefullComponent } from './Components/trinka-vs-writefull/trinka-vs-writefull.component';
import { PowerModeEditingComponent } from './Components/power-mode-editing/power-mode-editing.component';
import { LifeSciencesMedicineAndPharmaComponent } from './Components/enterprise/life-sciences-medicine-and-pharma/life-sciences-medicine-and-pharma.component';
import { LanguageServicesPublishingAndMediaComponent } from './Components/enterprise/language-services-publishing-and-media/language-services-publishing-and-media.component';
import { AcademicInstitutionsComponent } from './Components/enterprise/academic-institutions/academic-institutions.component';
import { K12AndElearningComponent } from './Components/enterprise/k12-and-elearning/k12-and-elearning.component';
import { TechnologyPlatformsComponent } from './Components/enterprise/technology-platforms/technology-platforms.component';
import { ConsistencyChecksComponent } from './Components/features/consistency-checks/consistency-checks.component';
import { PersonalDictionaryComponent } from './Components/features/personal-dictionary/personal-dictionary.component';
import { CreditsComponent } from './Components/features/credits/credits.component';
import { PlagiarismCheckerComponent } from './Components/features/plagiarism-checker/plagiarism-checker.component';
import { APIComponent } from './Components/enterprise/api/api.component';
import { PunctuationCheckerComponent } from './Components/punctuation-checker/punctuation-checker.component';
import { SpellCheckerComponent } from './Components/spell-checker/spell-checker.component';
import { SentenceCheckerComponent } from './Components/sentence-checker/sentence-checker.component';
import { CitationCheckerComponent } from './Components/features/citation-checker/citation-checker.component';
import { CitationSampleReportComponent } from './Components/features/citation-checker/citation-sample-report/citation-sample-report.component';
import { MacwordpluginComponent } from './Components/macwordplugin/macwordplugin.component';
import { FeedbackModalComponent } from './Components/feedback-modal/feedback-modal.component';
import { MultilingualEditorMarketingModule } from '@crimson-mohit/multilingual-editor-marketing';
import { DetectionLimitExhaustModalComponent } from './Components/detection-limit-exhaust-modal/detection-limit-exhaust-modal.component';
import { LatexGrammarCheckerComponent } from './Components/features/latex-grammar-checker/latex-grammar-checker.component';
import { ParapharsingToolComponent } from './Components/parapharsing-tool/parapharsing-tool.component';
import { AiDetectorToolComponent } from './Components/ai-detector-tool/ai-detector-tool.component';
import { AiContentFeedbackModalComponent } from './Components/ai-content-feedback-modal/ai-content-feedback-modal.component';
import { OnlineParaphraserComponent } from './Components/features/online-paraphraser/online-paraphraser.component';
import { EnglishGrammarCheckerComponent } from './Components/english-grammar-checker/english-grammar-checker.component';
import { DataSensitivePlanComponent } from './Components/enterprise/data-sensitive-plan/data-sensitive-plan.component';
import { GlobalLeadersComponent } from './Components/global-leaders/global-leaders.component';
import { TestimonialComponent } from './Components/testimonial/testimonial.component';
import { GrammarCheckerFeaturesComponent } from './Components/features/grammar-checker-features/grammar-checker-features.component';
import { InclusiveLanguageReportComponent } from './Components/features/inclusive-language-report/inclusive-language-report.component';
import { LegalWritingComponent } from './Components/features/legal-writing/legal-writing.component';
import { OfficialInvoiceComponent } from './Components/official-invoice/official-invoice.component';
import { SpanishGrammarCheckerComponent } from './Components/spanish-grammar-checker/spanish-grammar-checker.component';
import { ProofreadingToolComponent } from './Components/proofreading-tool/proofreading-tool.component';
import { CaseStudyComponent } from './Components/case-study/case-study.component';
import { NitComponent } from './Components/case-study/nit/nit.component';
import { GrammarCheckerToolComponent } from './grammar-checker-tool/grammar-checker-tool.component';
import { PostEventContactFromComponent } from './Components/post-event-contact-from/post-event-contact-from.component';
import { PowerModeSectionComponent } from './Components/features/power-mode-section/power-mode-section.component';
import { SuggestionAlertsComponent } from './Components/features/features-shared/suggestion-alerts/suggestion-alerts.component';
import { SpecializeWritingComponent } from './Components/features/features-shared/specialize-writing/specialize-writing.component';
import { DomainSpecificComponent } from './Components/features/features-shared/domain-specific/domain-specific.component';
import { OtherLanguagesComponent } from './Components/features/features-shared/other-languages/other-languages.component';
//import { EnterpriseModalComponent } from './Components/enterprise-modal/enterprise-modal.component';
import { SharedModule } from './modules/shared.module';
import { DocumarkComponent } from './Components/features/documark/documark.component';
import { EnterpriseModalModule } from './modules/enterprise-modal/enterprise-modal.module';
import { AcademicPhrasebankComponent } from './Components/academic-phrasebank/academic-phrasebank.component';
import { AcademicPhrasebankBrowseComponent } from './Components/academic-phrasebank-browse/academic-phrasebank-browse.component';
import { HighlightKeywordsDirective } from './_directives/highlightKeywords.directive';
import { PaginationComponent } from './Components/pagination/pagination.component';
import { TNQComponent } from './Components/case-study/tnq/tnq.component';
import { AskTrinkaComponent } from './Components/features/ai-studio/ask-trinka/ask-trinka.component';
import { SecuritySectionComponent } from './Components/security-section/security-section.component';
import { EnterpriseFormPageComponent } from './Components/enterprise-form-page/enterprise-form-page.component';
import { TranslationComponent } from './Components/features/translation/translation.component';
import { AIAppsLibraryComponent } from './Components/features/ai-studio/aiapps-library/aiapps-library.component';
import { AppsLibraryComponent } from './Components/features/ai-studio/apps-library/apps-library.component';
import { CertificateOfEditingComponent } from './Components/features/certificate-of-editing/certificate-of-editing.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    FeaturesComponent,
    ExamplesComponent,
    PricingComponent,
    EnterpriseComponent,
    wordpluginComponent,
    TrinkaCloudComponent,
    AboutUsComponent,
    ContactUsComponent,
    WorkWithUsComponent,
    PrivacyPolicyComponent,
    TermServicesComponent,
    PageNotFoundComponent,
    BrowserPluginComponent,
    AutoEditComponent,
    CompareComponent,
    GcEditorComponent,
    WhitePaperComponent,
    PublicationChecksComponent,
    FAQComponent,
    TrinkaVsGrammarlyComponent,
    TrinkaVsGingerComponent,
    TrinkaVsLanguagetoolComponent,
    TrinkaVsWritefullComponent,
    PowerModeEditingComponent,
    LifeSciencesMedicineAndPharmaComponent,
    LanguageServicesPublishingAndMediaComponent,
    AcademicInstitutionsComponent,
    K12AndElearningComponent,
    TechnologyPlatformsComponent,
    PersonalDictionaryComponent,
    CreditsComponent,
    ConsistencyChecksComponent,
    PlagiarismCheckerComponent,
    APIComponent,
    PunctuationCheckerComponent,
    SpellCheckerComponent,
    SentenceCheckerComponent,
    CitationCheckerComponent,
    CitationSampleReportComponent,
    MacwordpluginComponent,
    FeedbackModalComponent,
    DetectionLimitExhaustModalComponent,
    LatexGrammarCheckerComponent,
    ParapharsingToolComponent,
    AiDetectorToolComponent,
    AiContentFeedbackModalComponent,
    OnlineParaphraserComponent,
    EnglishGrammarCheckerComponent,
    DataSensitivePlanComponent,
    GlobalLeadersComponent,
    TestimonialComponent,
    GrammarCheckerFeaturesComponent,
    InclusiveLanguageReportComponent,
    LegalWritingComponent,
    OfficialInvoiceComponent,
    SpanishGrammarCheckerComponent,
    ProofreadingToolComponent,
    CaseStudyComponent,
    NitComponent,
    TNQComponent,
    GrammarCheckerToolComponent,
    PostEventContactFromComponent,
    PowerModeSectionComponent,
    SuggestionAlertsComponent,
    SpecializeWritingComponent,
    DomainSpecificComponent,
    OtherLanguagesComponent,
    //EnterpriseModalComponent,
    DocumarkComponent,
    AcademicPhrasebankComponent,
    AcademicPhrasebankBrowseComponent,
    HighlightKeywordsDirective,
    PaginationComponent,
    AskTrinkaComponent,
    SecuritySectionComponent,
    EnterpriseFormPageComponent,
    TranslationComponent,
    AIAppsLibraryComponent,
    AppsLibraryComponent,
    CertificateOfEditingComponent
  ],
  imports: [
    MultilingualEditorMarketingModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    MaterialModule,
    MaterialModuleList,
    AppRoutingModule,
    HttpClientModule,
    NgtUniversalModule,
    ToastrModule.forRoot(),
    TransferHttpCacheModule,
    CommonModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    ChangelogfyModule,
    SharedModule,
    EnterpriseModalModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class AppModule { }
